/* eslint-disable padding-line-between-statements */
import React, { useCallback, useEffect, useState } from 'react';
import { WizardPage } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { useTranslator } from '@jutro/locale';
import { Loader, useModal } from '@jutro/components';
import CustomLoader from 'producer-engage/src/components/CustomLoader/CustomLoader';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import UWUtil from "ent-capability-quoteandbind-common-react/util/UWUtil"
import _ from 'lodash';
import UnderwritingWarningComponent from "ent-capability-quoteandbind-common-react/components/UnderwritingWarningComponent/UnderwritingWarningComponent";
// import PrintDocumentUtil from "ent-capability-quoteandbind-common-react/util/PrintDocumentUtil.js";
import { CustomQuoteService } from 'twia-capability-quoteandbind-residential';
import PrintDocumentUtils from 'ent-capability-quoteandbind-common-react/util/PrintDocumentUtils.js';
import PrintDocumentConfirmationPopup from 'ent-capability-quoteandbind-common-react/pages/PrintDocument/PrintDocumentConfirmationPopup';
import PrintDocumentErrorPopup from 'ent-capability-quoteandbind-common-react/pages/PrintDocument/PrintDocumentErrorPopup';
import { GatewayRenewalService } from 'twia-capability-gateway-policyrenewal';
import styles from './QuotePage.module.scss';
import TWIAPolicySummary from '../../components/TWIAPolicySummary/TWIAPolicySummary';
import metadata from './QuotePage.metadata.json5';

function QuotePage(props) {
    const { id, wizardData: submissionVM, updateWizardData, goPrevious, onResolve, onAfterClose } = props;
    const { authHeader } = useAuthentication();
    const { isComponentValid, onValidate } = useValidation(id);
    const [showErrors, setShowErrors] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isPrinting, setIsPrinting] = useState(false);
    const translator = useTranslator();
    const { showAlert, showConfirm, showModal } = useModal();
    const isRenewal = _.get(submissionVM, 'baseData.jobType.value.code') === 'Renewal';
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const [errorDescription, setShowErrorDescription] = useState();

    useEffect(() => {
        if (isRenewal) {
            setIsLoading(true);

            const validationParams = {
                skipAllValidation: false,
                validationLevel: "default",
                validationWizardStep: "Quote"
            }
            
            _.set(submissionVM, 'validationParams_TWIA.value', validationParams);

            const quoteData = _.get(submissionVM.value, 'quoteData');
            const renewalVM = GatewayRenewalService.retrieveQuotedRenewalMessages_TWIA(submissionVM.value,
                authHeader);

            renewalVM.then((response) => {
                submissionVM.value = response;
                _.set(submissionVM, 'quoteData.value', quoteData);
                updateWizardData(submissionVM);

                if (_.get(submissionVM.value, 'errorsAndWarnings') &&
                    _.get(submissionVM.value, 'errorsAndWarnings.validationIssues')) {
                    const issues = submissionVM.value.errorsAndWarnings.validationIssues;

                    if (issues.issues && issues.issues.length > 0) {

                        if (_.isUndefined(issues.issues[0].flowStepId) && 
                        issues.issues[0].reason.includes("Please upload")) {
                            setShowErrorMessage(true);
                            setShowErrorDescription(issues.issues[0].reason);
                            setIsLoading(false);

                        }
                    }

                }

                setIsLoading(false);
            }).catch(() => {
                setIsLoading(false);
            })
        }
    }, [])

    // US26285
    // const quotePrintDocument = useCallback(async () => {
    //     setIsPrinting(true);
    //     await PrintDocumentUtil.printDocument(submissionVM, showConfirm, showAlert, translator, authHeader, setIsPrinting);
       

    // }, [authHeader, showAlert, showConfirm, submissionVM, translator])

    const quotePrintDocument = useCallback(() => {
        const {getPublicID, getPath, getQuoteStatus} = PrintDocumentUtils(submissionVM);
        setIsPrinting(true);
        
        const publicID = getPublicID();
        const docPath = getPath();
        const quoteStatus = getQuoteStatus();       
        const componentProps = { submissionVM, setIsPrinting, isOpen: true, onResolve, onAfterClose, docPath, quoteStatus};       
        if (quoteStatus === 'Quoted' || quoteStatus === 'Submitted_Ext' || quoteStatus === 'Renewing') {
            CustomQuoteService.generateDocument_TWIA(publicID, 'quoteSummary', authHeader).then(() => {
                showModal(<PrintDocumentConfirmationPopup {...componentProps} />);
            });
        }  else {
            showModal(<PrintDocumentErrorPopup {...componentProps} />);
        }
    }, [authHeader, onAfterClose, onResolve, showModal, submissionVM])

    const onEditCoverage = useCallback(() => {
        props.goPrevious();
    }, []);

    const showUWWarningComponent = useCallback(() => {
        if (_.get(submissionVM, 'errorsAndWarnings.underwritingIssues.value') !== undefined) {
            return UWUtil.checkUWIssues(_.get(submissionVM, 'errorsAndWarnings.underwritingIssues.value'))
        }

        return false
    }, [submissionVM])

    const onNext = useCallback(() => {
        if (!isComponentValid) {
            setShowErrors(true);
            return false
        }
        return submissionVM
    }, [isComponentValid, submissionVM])

    const overrideProps = {
        policySummary: {
            visible: !showUWWarningComponent(),
            submissionVM,
            isQuotePage: true,
            onEditCoverage
        },
        // US26427
        UnderwritingWarning: {
            submissionVM,
            visible: showUWWarningComponent()
        },
        infoMessage: {
            visible: showErrorMessage,
            message: errorDescription
        },
        quotePagePrint: {
            visible : !isPrinting
        },
        cLoader: {
            visible: isPrinting
        },
    }
    const resolvers = {
        resolveCallbackMap: {
            quotePrintDocument
        },
        resolveClassNameMap: styles,
        resolveComponentMap: {
            TWIAPolicySummary,
            UnderwritingWarningComponent,
            customLoader: CustomLoader
        }
    }

    return (
        <WizardPage
            onNext={onNext}
            disableNext={showUWWarningComponent()}
        >
            <Loader loaded={!isLoading}>
                <ViewModelForm
                    uiProps={metadata.pageContent}
                    model={submissionVM}
                    overrideProps={overrideProps}
                    onModelChange={updateWizardData}
                    onValidationChange={onValidate}
                    callbackMap={resolvers.resolveCallbackMap}
                    componentMap={resolvers.resolveComponentMap}
                    classNameMap={resolvers.resolveClassNameMap}
                    showErrors={showErrors}
                />
            </Loader>
        </WizardPage>
    )
}

export default QuotePage